// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

import ElementUI from 'element-ui'
import './assets/theme/element/index.css'
import './assets/iconfont/iconfont.js'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.use(Viewer, {
	defaultOptions: {
		zIndex: 9999,
		title:false,//    显示当前图片的标题
		scalable:false,//图片是否可翻转
		rotatable:false,//图片是否可旋转
		tooltip:false,//显示缩放百分比
		navbar:false,//显示缩略图导航
		loop:false,
		loading:false
		 }
	})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js